import React, { useState, useEffect } from "react";
import { SingleSelector, MultiSelector } from "./components/Selector";

export default function PlayersCriteria(props) {
	const criteria = props.criteria; //기본 criteria
	const data = props.data; //팀 목록, 선수 목록

	const [playerTit, setPlayerTit] = useState("선수");
	const [oppPlayerTit, setOppPlayerTit] = useState("선수");

	const [playerLang, setPlayerLang] = useState("player");
	const [oppPlayerLang, setOppPlayerLang] = useState("player");

	const [players, setPlayers] = useState();
	const [oppPlayers, setOppPlayers] = useState();
	const [teams, setTeams] = useState();
	const [oppTeams, setOppTeams] = useState();

	useEffect(() => {
		if (typeof data != "undefined") {
			if(data.teamInfo.length != 0 && data.teamInfo[0].value == 0){
				//만약 이미 '전체'가 들어가있으면 삭제 후 넘겨주기
				data.teamInfo.shift();
			}

			settingEngName();

			let teamInfos = separateTeams(data.teamInfo);
			let playerInfos = separatePlayers(data.playerInfo);

			//소속팀이 없는 선수 필터링
			let teamPlayerFilter = playerInfos.teamPlayers.filter(
				(player) => player.engTeamName != undefined
			);
			let oppTeamPlayerFilter = playerInfos.oppTeamPlayers.filter(
				(player) => player.engTeamName != undefined
			);

			setPlayers(teamPlayerFilter);
			setOppPlayers(oppTeamPlayerFilter);
			setTeams(teamInfos.teams);
			setOppTeams(teamInfos.oppTeams);
			settingPlayerTitle();

			// let teamPlayersArray = createArrays(playerInfos.teamPlayers);
			// let oppTeamPlayersArray = createArrays(playerInfos.oppTeamPlayers);

			// props.setWholePlayers(teamPlayersArray);
			// props.setOppWholePlayers(oppTeamPlayersArray);
		}
	}, [props.data, criteria]);

	const settingEngName = () => {
		data.playerInfo.map((player) => {
			data.teamInfo.map((team) => {
				if(player.teamId == team.teamId){
					player.teamName = team.teamName;
					player.engTeamName = team.engTeamName;
				}
			});
		});
	}

	const separateTeams = (teamInfos) => {
		let teams = teamInfos;
		let oppTeams = teamInfos.filter(
			(team) => team.teamId != criteria.teamId
		);
		settingTeamName(teams);
		settingTeamName(oppTeams);

		if(teamInfos.length == 0){
			//'없음' 옵션 추가
			teams.unshift({ value: 0, label: "없음", engTeamName:"None" });
			oppTeams.unshift({ value: 0, label: "없음", engTeamName:"None" });
		} else {
			//'전체' 옵션 추가
			teams.unshift({ value: 0, label: "전체", engTeamName:"Whole" });
			oppTeams.unshift({ value: 0, label: "전체", engTeamName:"Whole" });
		}

		return { teams: teams, oppTeams: oppTeams };
	};

	const separatePlayers = (playerInfos) => {
		let teamPlayers = playerInfos.filter(
			(player) =>
				player.position === criteria.position &&
				(Number(criteria.teamId) === 0 ||
					Number(player.teamId) === Number(criteria.teamId))
		);
		let oppTeamPlayers = playerInfos.filter(
			(player) =>
				player.position !== criteria.position &&
				(Number(criteria.oppTeamId) === 0 ||
					Number(player.teamId) === Number(criteria.oppTeamId))
		);

		settingPlayerName(teamPlayers);
		settingPlayerName(oppTeamPlayers);

		return { teamPlayers: teamPlayers, oppTeamPlayers: oppTeamPlayers };
	};

	const settingPlayerName = (players) => {
		players.map((player) => {
			player.label = `#${player.backnumber} ${player.playerName}`;
			player.value = player.playerId;
			player.engName = `#${player.backnumber} ${player.lastName} ${player.firstName}`;
			player.fullLabel = `#${player.backnumber} ${player.playerName} (${player.teamName})`;
			player.fullEngName = `#${player.backnumber} ${player.lastName} ${player.firstName} (${player.engTeamName})`;
		});
	};

	const settingTeamName = (teams) => {
		teams.map((team) => {
			if(team.value != 0){
				team.label = `${team.teamName}`;
				team.value = Number(team.teamId);
			}
		});
	};

	const settingPlayerTitle = () => {
		let title = criteria.position === "batter" ? "타자" : "투수";
		let oppTitle = criteria.position === "batter" ? "투수" : "타자";
		setPlayerTit(title);
		setOppPlayerTit(oppTitle);
		let p_lang = criteria.position === "batter" ? "hitter" : "pitcher";
		let opp_lang = criteria.position === "batter" ? "pitcher" : "hitter";

		setPlayerLang(p_lang);
		setOppPlayerLang(opp_lang);
	};

	// const createArrays = (obj) => {
	// 	 return obj.map(row => row.value);
	// }

	return (
		<div className="row">
			<div className="col-6">
				<SingleSelector
					title={"팀"}
					id={"teamId"}
					name={"teamId"}
					value={criteria.teamId}
					options={teams}
					setValue={props.changeTeamHandler}
					placeHolder={"팀을 선택해 주세요."}
					dataLang={"team"}
					useLang={props.useLang}
				/>
				<MultiSelector
					title={playerTit}
					id="playerIds"
					name="playerIds"
					options={players}
					value={criteria.playerIds}
					setValue={props.playerChangeHandler}
					placeHolder={props.useLang == 'en' ? "Select Player" : "선수 선택"}
					dataLang={playerLang}
					useLang={props.useLang}
					teamId={criteria.teamId}
				/>
			</div>
			<div className="col-6">
				<SingleSelector
					title={"상대팀"}
					id={"oppTeamId"}
					name={"oppTeamId"}
					value={criteria.oppTeamId}
					options={oppTeams}
					setValue={props.changeTeamHandler}
					placeHolder={"상대팀을 선택해 주세요."}
					dataLang={"oppTeam"}
					useLang={props.useLang}
				/>
				<MultiSelector
					title={oppPlayerTit}
					id={"oppPlayerIds"}
					name={"oppPlayerIds"}
					value={criteria.oppPlayerIds}
					options={oppPlayers}
					setValue={props.playerChangeHandler}
					placeHolder={props.useLang == 'en' ? "Select Opp Player" : "상대 선수 선택"}
					dataLang={oppPlayerLang}
					useLang={props.useLang}
					teamId={criteria.oppTeamId}
				/>
			</div>
		</div>
	);
}
